import LiveAccessFloatingActionToolbar from './LiveAccessFloatingActionToolbar'

export default LiveAccessFloatingActionToolbar
// eslint-disable-next-line import/export
export * from './LiveAccessFloatingActionToolbar'
